__turbopack_context__.v({
  "cell": "RichTextTable-module__rd0tQq__cell",
  "cellHasCta": "RichTextTable-module__rd0tQq__cellHasCta",
  "colHidden": "RichTextTable-module__rd0tQq__colHidden",
  "firstCol33": "RichTextTable-module__rd0tQq__firstCol33",
  "firstCol50": "RichTextTable-module__rd0tQq__firstCol50",
  "lastColHidden": "RichTextTable-module__rd0tQq__lastColHidden",
  "richTextTable": "RichTextTable-module__rd0tQq__richTextTable",
  "rowHasCta": "RichTextTable-module__rd0tQq__rowHasCta",
  "tbodyLightGreenColorway": "RichTextTable-module__rd0tQq__tbodyLightGreenColorway",
  "tbodyMediumGreenColorway": "RichTextTable-module__rd0tQq__tbodyMediumGreenColorway",
  "tbodyWhiteColorway": "RichTextTable-module__rd0tQq__tbodyWhiteColorway",
});
